import React, { useState } from 'react';
import MessagesList from './MessagesList';
import MessageDetail from './MessageDetail';

const Messages = () => {
  const [selectedConversation, setSelectedConversation] = useState(null);

  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
  };

  const handleBack = () => {
    setSelectedConversation(null);
  };

  const handleUpdate = () => {
    // Recharger la liste si on est dans la vue liste
    if (!selectedConversation) {
      window.location.reload();
    }
  };

  return (
    <div className="w-full">
      {selectedConversation ? (
        <MessageDetail 
          conversation={selectedConversation} 
          onBack={handleBack}
          onUpdate={handleUpdate}
        />
      ) : (
        <MessagesList onSelectConversation={handleSelectConversation} />
      )}
    </div>
  );
};

export default Messages;
